/* eslint-disable no-void */
import * as Sentry from '@sentry/nextjs';
import React, { useEffect } from 'react';
import AppContext, { appContextInitialState } from '~/context/AppContext';
import { useMeLazyQuery, useMyPhotoLazyQuery } from '~/generated/apollo';
import getBase64Image from '~/helpers/getBase64Image';
import getExamineePhoto from '~/helpers/getExamineePhoto';
import getToken from '~/helpers/token/getToken';
import useLogger from '~/hooks/useLogger';
const CacheUserPhoto = (): null => {
  const appContext = React.useContext(AppContext);
  const logger = useLogger('CacheUserPhoto');
  const tokenObj = typeof window !== 'undefined' ? getToken() : null;
  const userIsSignedIn = tokenObj ? tokenObj.exp * 1000 > Date.now() : false;
  const [executeMeQuery] = useMeLazyQuery();
  const [executeMyPhotoQuery] = useMyPhotoLazyQuery({});
  const cacheUserPhoto = async (): Promise<void> => {
    await appContext.actions.update({
      examineePhotoIsLoading: true
    });
    let photoExempt = false;
    let url = '';
    try {
      const {
        data: dataMe
      } = await executeMeQuery({
        fetchPolicy: 'network-only'
      });
      photoExempt = dataMe?.me.photoExempt || false;
      const {
        data: dataMyPhoto
      } = await executeMyPhotoQuery({
        fetchPolicy: 'network-only'
      });
      url = dataMyPhoto?.myPhotoUrl?.url || '';
    } catch (err) {
      Sentry.captureException(err);
      logger.log(err);
    }
    const imageUrl = getExamineePhoto({
      photoExempt,
      url
    });
    await getBase64Image(imageUrl).then(base64Image => appContext.actions.update({
      examineePhotoSrc: base64Image?.toString()
    })).catch(() => appContext.actions.update({
      examineePhotoSrc: '/static/img/avatar-examinee-default.png'
    }));
    await appContext.actions.update({
      examineePhotoIsLoading: false
    });
  };
  const invalidateUserPhoto = async (): Promise<void> => {
    await appContext.actions.update({
      examineePhotoSrc: appContextInitialState.examineePhotoSrc
    });
  };
  useEffect(() => {
    if (userIsSignedIn) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      cacheUserPhoto();
    } else {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      invalidateUserPhoto();
    }
  }, [userIsSignedIn]);
  return null;
};
export default CacheUserPhoto;